module.exports = __webpack_public_path__ + "static/profile-1bd5bf3642f4363d0be9e014c24db64a.png";